<app-widget-card-wrapper title="Recent Monitoring Information" [hide]="false">
  <div class="card-stretch text-center">
    <app-sign-post-charts [toDate]="toDate" [timeScale]="timeScale"></app-sign-post-charts>
  </div>
</app-widget-card-wrapper>
